import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.map.js";
import { createTableActionItem, createTableColumn, createTableColumnSlot, createTableHeaderButton } from "@/component-create/utils/create-table-column";
import { Table } from "@/component-create/Table";
import { MESSAGE_RECIPIENT, MESSAGE_STATUS, MESSAGE_TYPE } from "@/constant/system/code";
import { ElLink, ElTag, ElSwitch } from "element-plus";
import 'element-plus/es/components/link/style/css'
import 'element-plus/es/components/tag/style/css'
import 'element-plus/es/components/switch/style/css'

import { View } from '@element-plus/icons-vue';
import { MESG_PAGE_URL, remove, updateStatus } from "@/api/system/message";
import { deleteBox, toast } from "@/utils/message";
var statusUpdating = ref(false);
var tb;
var searchData;
export var createMessageTable = function createMessageTable(el, row, header, sdata) {
  var _table = new Table(el, column(row), headerButtons(header), {
    border: true
  }, MESG_PAGE_URL);
  tb = _table;
  searchData = sdata;
  return _table;
};
export var column = function column(rowFn) {
  var col = [{
    type: 'selection'
  }, {
    label: '序号',
    type: 'index',
    width: '60'
  }, createTableColumn('主题', 'subject'), createTableColumnSlot('内容', function (row) {
    return _createVNode(ElLink, {
      "onClick": function onClick() {
        rowFn.rowShow(row, []);
      },
      "type": "primary",
      "underline": false,
      "icon": View
    }, {
      default: function _default() {
        return [_createVNode("span", {
          "style": {
            paddingLeft: '8px'
          }
        }, [_createTextVNode("\u67E5\u770B\u5185\u5BB9")])];
      }
    });
  }, {
    width: '120',
    align: 'center'
  }), createTableColumn('备注', 'remark', undefined, undefined, {
    showOverflowTooltip: true
  }), createTableColumnSlot('类型', function (row) {
    if (row.type === MESSAGE_TYPE.NOTICE.CODE) {
      return h(_createVNode(ElTag, {
        "type": "success",
        "size": "small"
      }, {
        default: function _default() {
          return [MESSAGE_TYPE.NOTICE.NAME];
        }
      }));
    } else if (row.type === MESSAGE_TYPE.MESSAGE.CODE) {
      return h(_createVNode(ElTag, {
        "size": "small"
      }, {
        default: function _default() {
          return [MESSAGE_TYPE.MESSAGE.NAME];
        }
      }));
    } else {
      return h(_createVNode("div", null, null));
    }
  }, {
    align: 'center',
    width: '100'
  }), createTableColumnSlot('收件人', function (row) {
    if (row.recipient === MESSAGE_RECIPIENT.ALL.CODE) {
      return h(_createVNode(ElTag, {
        "type": "success",
        "size": "small"
      }, {
        default: function _default() {
          return [MESSAGE_RECIPIENT.ALL.NAME];
        }
      }));
    } else if (row.recipient === MESSAGE_RECIPIENT.DEPT.CODE) {
      return h(_createVNode(ElTag, {
        "size": "small"
      }, {
        default: function _default() {
          return [MESSAGE_RECIPIENT.DEPT.NAME];
        }
      }));
    } else if (row.recipient === MESSAGE_RECIPIENT.USER.CODE) {
      return h(_createVNode(ElTag, {
        "type": "info",
        "size": "small"
      }, {
        default: function _default() {
          return [MESSAGE_RECIPIENT.USER.NAME];
        }
      }));
    } else {
      return h(_createVNode("div", null, null));
    }
  }, {
    width: '120',
    align: 'center'
  }), createTableColumn('作者', 'author', '120'), createTableColumnSlot('是否发布', function (row) {
    return h(_createVNode(ElSwitch, {
      "modelValue": row.status,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return row.status = $event;
      },
      "active-value": MESSAGE_STATUS.PUBLISHED.CODE,
      "inactive-value": MESSAGE_STATUS.DRAFTED.CODE,
      "disabled": statusUpdating.value,
      "onChange": function onChange() {
        handleUpdateStatus(row);
      }
    }, null));
  }, {
    width: '100',
    align: 'center'
  }), createTableColumn('发布时间', 'pubDate', '160', 'center', {
    sortable: true
  }), createTableColumn('创建时间', 'createdAt', '160', 'center', {
    sortable: true
  }), createTableColumn('操作', undefined, '200', 'center', {
    controller: [createTableActionItem('编辑', 'Edit', rowFn.rowEdit), createTableActionItem('删除', 'Delete', function (row) {
      deleteBox().then(function () {
        remove([row.id]).then(function () {
          toast.success('删除成功');
          tb.load(searchData.value);
        });
      });
    })]
  })];
  return col;
};
/**
 * 表格头部按钮
 */
function headerButtons(table) {
  return [createTableHeaderButton('新增', 'primary', 'Plus', table.addFn), createTableHeaderButton('编辑', 'primary', 'Edit', table.editFn), createTableHeaderButton('删除', 'primary', 'Delete', function (rows) {
    if (rows.length > 0) {
      deleteBox().then(function () {
        remove(rows.map(function (i) {
          return i.id;
        })).then(function () {
          toast.success('删除成功');
          tb.load(searchData.value);
        });
      });
    } else {
      toast.warn('请至少选择一条数据');
    }
  })];
}
function handleUpdateStatus(data) {
  statusUpdating.value = true;
  updateStatus(data).then(function () {
    toast.success('状态更新成功');
  }).catch(function () {
    if (data.status === MESSAGE_STATUS.DRAFTED.CODE) {
      data.status = MESSAGE_STATUS.PUBLISHED.CODE;
    } else {
      data.status = MESSAGE_STATUS.DRAFTED.CODE;
    }
  }).finally(function () {
    statusUpdating.value = false;
  });
}